import React from 'react';

//components
import BrandLogo from  '@/components/elements/global/brandLogo/BrandLogo';



const WorkspaceIconAndName = ({icon, workspaceName}: {icon: string, workspaceName: string}) => {
    return (
        <div className='workspace-icon-name'>
            <BrandLogo imageUrl={icon} altText={`Brand Logo for ${workspaceName}`} /> 

            {workspaceName}
        </div> 
    )
}

export default WorkspaceIconAndName